import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Nav, NavItem, Breadcrumb, BreadcrumbItem, Button } from 'reactstrap'
import {
  sendPost
} from '../../../actions/adminActions'
import { withRouter } from 'react-router'
import Loading from '../../loading'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import { Document, Page } from 'react-pdf/dist/entry.webpack'
import { FaEnvelope, FaFilePdf } from 'react-icons/fa'

class AdminAppealPDF extends Component {
  constructor (props) {
    super(props)
    this.setPDFSize = this.setPDFSize.bind(this)
    this.state = {
      numPages: null,
      pageNumber: 1,
      pdfWidth: 100
    }
    this.pdfArea = React.createRef(this.pdfArea)

    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this)
  }

  componentDidMount () {
    if (!this.props.admin.appeal.appealID || !this.props.admin.pdf) {
      this.props.goBackToAppeal(this.props.match.params.appealID)
      return
    }
    this.setPDFSize()
    window.addEventListener('resize', this.setPDFSize)
  }

  setPDFSize () {
    this.setState({ pdfWidth: (this.pdfArea.current.getBoundingClientRect().width - 40) })
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.setPDFSize)
  }

  onDocumentLoadSuccess ({ numPages }) {
    this.setState({ numPages })
  }

  render () {
    let theChild

    if (this.props.admin.appeal.appealID) {
      theChild =
        <Container>
          <Row>
            <Col>
              <Breadcrumb>
                <BreadcrumbItem><Link to='/admin'>Appeals</Link></BreadcrumbItem>
                <BreadcrumbItem><Link to={`/admin/appeal/${this.props.admin.appeal.appealID}`}>{this.props.admin.appeal.pcn}</Link></BreadcrumbItem>
                <BreadcrumbItem active><Link to={`/admin/appeal/${this.props.admin.appeal.appealID}/messaging`}>Messaging</Link></BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
          <Row>
            <Col>
              <Nav fill tabs className='mb-3'>
                <NavItem>
                  <Link className='nav-link' to={`/admin/appeal/${this.props.admin.appeal.appealID}`}>Details</Link>
                </NavItem>
                <NavItem>
                  <Link className='nav-link active' to={`/admin/appeal/${this.props.admin.appeal.appealID}/messaging`}>Messaging</Link>
                </NavItem>
              </Nav>
            </Col>
          </Row>
          <Row>
            <Col sm='12' md='8'>
              <div ref={this.pdfArea} className='pdf-holder'>
                <Document onLoadSuccess={this.onDocumentLoadSuccess} file={this.props.admin.pdf}>
                  {
                    Array.from(
                      new Array(this.state.numPages),
                      (el, index) => (
                        <Page
                          width={this.state.pdfWidth}
                          key={`page_${index + 1}`}
                          pageNumber={index + 1}
                        />
                      )
                    )
                  }
                </Document>
              </div>
            </Col>
            <Col sm='12' md='4'>
              <Button className='mr-2' color='primary' onClick={this.props.sendPost} disabled={this.props.admin.posting}><FaEnvelope /> Post <span className='spinning' /></Button>
              <a className='btn btn-secondary mr-2' target='_blank' href={this.props.admin.pdf}><FaFilePdf /> Download</a>
              <Link className='btn btn-secondary mr2' to={`/admin/appeal/${this.props.admin.appeal.appealID}/messaging`}>Cancel</Link>

            </Col>
          </Row>

        </Container>
    } else {
      theChild = <Loading />
    }

    return (
      <div>
        {theChild}
      </div>
    )
  }
};

AdminAppealPDF.propTypes = {
  sendPost: PropTypes.func,
  admin: PropTypes.object,
  match: PropTypes.object,
  goBackToAppeal: PropTypes.func
}

const mapStateToProps = ({ admin }) => ({
  admin,
  replies: admin.appeal.replies ? Array.from(admin.appeal.replies.values) : []
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      sendPost,
      goBackToAppeal: (id) => (push(`/admin/appeal/${id}/messaging`))
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminAppealPDF))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminAppeal/AdminAppealPDF.jsx